import React from "react";
import SiteDocumentation from "./SiteDocumentation";

export default function XMQ_documentation() {
    return <SiteDocumentation page="index"/>;
}
